class DeliverySaverAnalytics {
    constructor(analytics) {
        this.analytics = analytics;
    }

    push(subscription, plan) {
        this.analytics.push({
            data: {
                subscription,
                plan,
            },
            type: this.analytics.mapperTypes.deliveryPlus,
        });
    }
}

DeliverySaverAnalytics.$inject = ['AnalyticsService'];

module.exports = { DeliverySaverAnalytics };



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-analytics.service.js